import api from './api';

class UserService {

    me(){
        return api.post('user/me')
    }

    update(data){
        return api.post('user/update', data)
    }

    getData(data){
        return api.post('user/getdata', data)
    }

    users(){
        return api.post('user/users')
    }

    getMarkerTemplate(){
        return api.post('user/get-marker-template')
    }

    updateMarkerTemplate(data){
        return api.post('user/update-marker-template', data)
    }

    getPermissions(data){
        return api.post('user/getpermissions', data)
    }

    toggleFakeData() {
        return api.post('user/toggleFakeData')
    }
    getFakeDataEnabled() {
        return api.post('user/getFakeDataEnabled')
    }
}

export default new UserService();